import React, { useEffect, useRef, useState } from 'react';
import { CSSTransition } from 'react-transition-group';
import { FormControlLabel, Switch } from '@mui/material';
import { makeStyles } from '@mui/styles';
import { styled as muiStyled } from '@mui/material/styles';

import color from 'utils/constants/color';
import styled, { keyframes } from 'styled-components';
import {get} from "lodash";
import usePopUpAtOnce from './hooks/usePopUpAtOnce';

// import { Switch } from 'antd';



const Container = styled.div`
  // margin-top: 10px;
  // margin-bottom: 10px;
  // margin-bottom: 5px;
`;

const fadeIn = keyframes`
  from {
    opacity: 0;
    transform: translateY(-10px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
`;

const LinkContainer = styled.div`
  max-height: 300px;
  overflow: auto;
  margin-top: 10px;
  background-color: ${color.green100};
  padding: 8px;
  border-radius: 4px;
  position: absolute;
  z-index: 11;
  top: 21px;
  left: 10px;

  &.fade-enter {
    opacity: 0;
    transform: translateY(-10px);
  }
  &.fade-enter-active {
    opacity: 1;
    transform: translateY(0);
    transition: opacity 300ms, transform 300ms;
  }
  &.fade-exit {
    opacity: 1;
    transform: translateY(0);
  }
  &.fade-exit-active {
    opacity: 0;
    transform: translateY(-10px);
    transition: opacity 300ms, transform 300ms;
  }
`;

const LinkItem = styled.div`
  margin-bottom: 5px;
  color: #fff;
  white-space: pre-line;
`;
const LinksItem = styled.a`
    color: #fff;
    text-decoration: none;
    background-color: transparent;
    outline: none;
    cursor: pointer;
    transition: color 0.3s;
    font-size: 14px;
    &:hover {
        color: ${color.white};
    }
    &:before {
        display: inline-block;
        content: '';
        -webkit-border-radius: 0.375rem;
        border-radius: 0.375rem;
        height: 0.55rem;
        width: 0.55rem;
        margin-right: 0.5rem;
        background-color: #fff;
    }
`;
const useStyles = makeStyles({
    root: {
        margin: '5px',
        width: '175px'
    },
    sizeSmall: {
        width: '50px',
        height: '25px'
    },
    checkedSwitch: {
        transform: 'translateX(20px) !important'
    },
    label: {
        textTransform: 'uppercase',
    },
});
const LinkList = ({ links, ebookFlagPageLink, setEbookFlagPageLink }) => {
  const nodeRef = useRef();
  const [isVisible, setIsVisible] = useState(false);
  const classes = useStyles();
    const { updatePopUpAtOnce,checkPopUpAtOnce,openPopUpAtOnce } = usePopUpAtOnce();

  useEffect(() => {
    if(ebookFlagPageLink){
      setIsVisible(true);
    } else {
      setIsVisible(false);
    }
  }, [ebookFlagPageLink])

  const handleSwitchChange = async (checked) => {
    if(checked){
      if(openPopUpAtOnce){ 
        checkPopUpAtOnce();
        return;
      }
      setEbookFlagPageLink(true);
      updatePopUpAtOnce(true);
    }else if(!checked){
      setEbookFlagPageLink(false);
      updatePopUpAtOnce(false);
    }
  };

  if (!links || links.length === 0) {
    return null;
  }
  const getLink = (link) => {
    try {
      if (typeof link == "string") {
        return link.match(/\bhttps?:\/\/\S+/gi)[0];
      } else if (typeof link == "object") {
        return get(link, "href", "").match(/\bhttps?:\/\/\S+/gi)[0];
      } else {
        return "";
      }
    } catch (error) {
      console.log(error);
    }
  };
const getHrefTitle = (link) => {
    if (typeof link == "string") {
        return link;
    } else if (typeof link == "object") {
        return link.title && link.title.length > 0 ? link.title : link.href;
    } else {
        return ''
    }
}

const StyledSwitch = muiStyled(Switch)(({ theme }) => ({
  '&.MuiSwitch-sizeSmall': {
    width: "40px",
    height: "25px",
  },
  '& .Mui-checked': {
    transform: "translateX(17px) !important",
  }
}));

  return (
    <Container className="relative">
          <FormControlLabel className='showLinkSection'
              classes={{
                  root: classes.root,
                  label: classes.label,
              }}
              control={
                  <StyledSwitch
                      classes={{
                          sizeSmall: classes.sizeSmall,
                          checked: classes.checkedSwitch
                      }}
                      checked={isVisible}
                      onChange={e => handleSwitchChange(e.target.checked)}
                      name="viewFlag"
                      color="primary"
                      size="small"
                  />
              }
              label={'Page Links'}
          />
      <CSSTransition
        in={isVisible}
        timeout={300}
        classNames="fade"
        unmountOnExit
        nodeRef={nodeRef}
        className="etxActvtyDropDwn"
      >
        <LinkContainer ref={nodeRef}>
          {links.map((link, index) => (
            <LinkItem key={index}>
                <LinksItem href={getLink(link)} target={"_blank"}  rel="noopener noreferrer"  >{getHrefTitle(link)}</LinksItem>
            </LinkItem>
          ))}
        </LinkContainer>
      </CSSTransition>
    </Container>
  );
};

export default LinkList;